// // components/FollowUpForm.jsx
// import React, { useState } from 'react';
// import { clientVisitAPI } from '../../common/clientVisitApi';

// const FollowUpForm = ({ visitId, clientId, isOpen, onClose, onSuccess }) => {
//   const [formData, setFormData] = useState({
//     followUpDate: '',
//     followUpTime: '',
//     followUpType: 'inPerson',
//     remarks: '',
//     rescheduleReason: ''
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // API call to add follow-up
//       await clientVisitAPI.addFollowUp(visitId, formData);
//       onSuccess();
//       // Reset form
//       setFormData({
//         followUpDate: '',
//         followUpTime: '',
//         followUpType: 'inPerson',
//         remarks: '',
//         rescheduleReason: ''
//       });
//     } catch (error) {
//       console.error('Error adding follow-up:', error);
//       alert('Failed to add follow-up');
//     }
//   };

//   return (
//     <>
//       {/* Overlay */}
//       <div 
//         className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
//           isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
//         }`}
//         onClick={onClose}
//       />

//       {/* Offcanvas */}
//       <div className={`fixed inset-y-0 right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
//         isOpen ? 'translate-x-0' : 'translate-x-full'
//       }`}>
//         {/* Header */}
//         <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-4 sm:px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h2 className="text-lg sm:text-xl font-bold text-white">Schedule Follow-up</h2>
//               <p className="text-sm text-blue-100 mt-1">Client ID: {clientId}</p>
//             </div>
//             <button
//               onClick={onClose}
//               className="p-2 hover:bg-white/20 rounded-lg transition-colors"
//             >
//               <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Form */}
//         <div className="h-full overflow-y-auto pb-32">
//           <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
//             {/* Follow-up Type */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Follow-up Type
//               </label>
//               <div className="grid grid-cols-3 gap-3">
//                 {[
//                   { value: 'inPerson', label: '📞 inPerson', color: 'blue' },
//                   { value: 'in-person', label: '🤝 In Person', color: 'green' },
//                   { value: 'virtual', label: '💻 Virtual', color: 'purple' }
//                 ].map((type) => (
//                   <button
//                     key={type.value}
//                     type="button"
//                     onClick={() => setFormData({ ...formData, followUpType: type.value })}
//                     className={`px-4 py-3 rounded-lg border-2 transition-all ${
//                       formData.followUpType === type.value
//                         ? `border-${type.color}-500 bg-${type.color}-50 text-${type.color}-700`
//                         : 'border-gray-200 hover:border-gray-300'
//                     }`}
//                   >
//                     <span className="text-lg mb-1 block">{type.label.split(' ')[0]}</span>
//                     <span className="text-xs">{type.label.split(' ')[1]}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Date and Time */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Follow-up Date <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="date"
//                   value={formData.followUpDate}
//                   onChange={(e) => setFormData({ ...formData, followUpDate: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Time <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="time"
//                   value={formData.followUpTime}
//                   onChange={(e) => setFormData({ ...formData, followUpTime: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Remarks */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Remarks
//               </label>
//               <textarea
//                 value={formData.remarks}
//                 onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
//                 rows={4}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
//                 placeholder="Add any notes or agenda items for the follow-up..."
//               />
//             </div>

//             {/* Reschedule Reason (optional) */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Reschedule Reason (if applicable)
//               </label>
//               <input
//                 type="text"
//                 value={formData.rescheduleReason}
//                 onChange={(e) => setFormData({ ...formData, rescheduleReason: e.target.value })}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 placeholder="Why is this being rescheduled?"
//               />
//             </div>

//             {/* Quick Templates */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Quick Templates
//               </label>
//               <div className="flex flex-wrap gap-2">
//                 {[
//                   'Product Demo',
//                   'Price Discussion',
//                   'Technical Review',
//                   'Contract Negotiation',
//                   'Final Decision'
//                 ].map((template) => (
//                   <button
//                     key={template}
//                     type="button"
//                     onClick={() => setFormData({ 
//                       ...formData, 
//                       remarks: formData.remarks ? `${formData.remarks}\n${template}` : template 
//                     })}
//                     className="px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
//                   >
//                     {template}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Submit Button - Fixed at Bottom */}
//             <div className="fixed bottom-0 right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white border-t border-gray-200 px-4 sm:px-6 py-4">
//               <div className="flex gap-3">
//                 <button
//                   type="button"
//                   onClick={onClose}
//                   className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
//                 >
//                   Schedule Follow-up
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FollowUpForm;


// // components/FollowUpForm.jsx
// import React, { useState } from 'react';
// import axios from 'axios';

// const FollowUpForm = ({ visitId, clientId, isOpen, onClose, onSuccess }) => {
//   const token = localStorage.getItem('ata');
//   const [formData, setFormData] = useState({
//     visitDate: '',
//     visitTime: '',
//     visitType: 'inPerson',
//     nextFollowUpDate: '',
//     remarks: ''
//   });

//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
    
//     try {
//       const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
//       // API call to add follow-up
//       const response = await axios.post(
//         `${apiUrl}/api/client-visits/follow-up/${visitId}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           }
//         }
//       );

//       if (response.data.success) {
//         alert('Follow-up added successfully!');
//         onSuccess();
        
//         // Reset form
//         setFormData({
//           visitDate: '',
//           visitTime: '',
//           visitType: 'inPerson',
//           nextFollowUpDate: '',
//           remarks: ''
//         });
//       }
//     } catch (error) {
//       console.error('Error adding follow-up:', error);
//       alert(error.response?.data?.message || 'Failed to add follow-up');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* Overlay */}
//       <div 
//         className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
//           isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
//         }`}
//         onClick={onClose}
//       />

//       {/* Offcanvas */}
//       <div className={`fixed inset-y-0 right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
//         isOpen ? 'translate-x-0' : 'translate-x-full'
//       }`}>
//         {/* Header */}
//         <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-4 sm:px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h2 className="text-lg sm:text-xl font-bold text-white">Schedule Follow-up Visit</h2>
//               <p className="text-sm text-blue-100 mt-1">Client ID: {clientId}</p>
//             </div>
//             <button
//               onClick={onClose}
//               className="p-2 hover:bg-white/20 rounded-lg transition-colors"
//             >
//               <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Form */}
//         <div className="h-full overflow-y-auto pb-32">
//           <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
//             {/* Visit Type */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Visit Type <span className="text-red-500">*</span>
//               </label>
//               <div className="grid grid-cols-3 gap-3">
//                 {[
//                   { value: 'inPerson', label: '📞 inPerson', color: 'blue' },
//                   { value: 'in-person', label: '🤝 In Person', color: 'green' },
//                   { value: 'virtual', label: '💻 Virtual', color: 'purple' }
//                 ].map((type) => (
//                   <button
//                     key={type.value}
//                     type="button"
//                     onClick={() => setFormData({ ...formData, visitType: type.value })}
//                     className={`px-4 py-3 rounded-lg border-2 transition-all ${
//                       formData.visitType === type.value
//                         ? type.value === 'inPerson' ? 'border-blue-500 bg-blue-50 text-blue-700' :
//                           type.value === 'in-person' ? 'border-green-500 bg-green-50 text-green-700' :
//                           'border-purple-500 bg-purple-50 text-purple-700'
//                         : 'border-gray-200 hover:border-gray-300'
//                     }`}
//                   >
//                     <span className="text-lg mb-1 block">{type.label.split(' ')[0]}</span>
//                     <span className="text-xs">{type.label.split(' ').slice(1).join(' ')}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Visit Date and Time */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Visit Date <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="date"
//                   value={formData.visitDate}
//                   onChange={(e) => setFormData({ ...formData, visitDate: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   required
//                   min={new Date().toISOString().split('T')[0]}
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Visit Time
//                 </label>
//                 <input
//                   type="time"
//                   value={formData.visitTime}
//                   onChange={(e) => setFormData({ ...formData, visitTime: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 />
//               </div>
//             </div>

//             {/* Next Follow-up Date */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Next Follow-up Date (Optional)
//               </label>
//               <input
//                 type="date"
//                 value={formData.nextFollowUpDate}
//                 onChange={(e) => setFormData({ ...formData, nextFollowUpDate: e.target.value })}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 min={formData.visitDate || new Date().toISOString().split('T')[0]}
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Leave empty if no follow-up is needed after this visit
//               </p>
//             </div>

//             {/* Remarks */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Visit Remarks / Notes
//               </label>
//               <textarea
//                 value={formData.remarks}
//                 onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
//                 rows={4}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
//                 placeholder="Add any notes, discussion points, or outcomes from this visit..."
//               />
//             </div>

//             {/* Quick Templates */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Quick Templates
//               </label>
//               <div className="flex flex-wrap gap-2">
//                 {[
//                   'Product Demo Scheduled',
//                   'Price Negotiation',
//                   'Technical Discussion',
//                   'Contract Review',
//                   'Requirements Gathering',
//                   'Final Decision Pending'
//                 ].map((template) => (
//                   <button
//                     key={template}
//                     type="button"
//                     onClick={() => {
//                       const currentRemarks = formData.remarks;
//                       const newRemarks = currentRemarks 
//                         ? `${currentRemarks}\n- ${template}` 
//                         : `- ${template}`;
//                       setFormData({ ...formData, remarks: newRemarks });
//                     }}
//                     className="px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
//                   >
//                     {template}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Visit Summary Preview */}
//             {(formData.visitDate || formData.visitType || formData.remarks) && (
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                 <h4 className="text-sm font-medium text-blue-900 mb-2">Visit Summary Preview</h4>
//                 <div className="space-y-1 text-xs text-blue-700">
//                   {formData.visitDate && (
//                     <p>
//                       <span className="font-medium">Date:</span> {new Date(formData.visitDate).toLocaleDateString('en-IN', {
//                         weekday: 'long',
//                         day: '2-digit',
//                         month: 'short',
//                         year: 'numeric'
//                       })}
//                       {formData.visitTime && ` at ${formData.visitTime}`}
//                     </p>
//                   )}
//                   <p>
//                     <span className="font-medium">Type:</span> {
//                       formData.visitType === 'in-person' ? '🤝 In Person' :
//                       formData.visitType === 'virtual' ? '💻 Virtual' :
//                       '📞 inPerson Call'
//                     }
//                   </p>
//                   {formData.nextFollowUpDate && (
//                     <p>
//                       <span className="font-medium">Next Follow-up:</span> {new Date(formData.nextFollowUpDate).toLocaleDateString('en-IN')}
//                     </p>
//                   )}
//                   {formData.remarks && (
//                     <div className="mt-2">
//                       <span className="font-medium">Notes:</span>
//                       <p className="mt-1 whitespace-pre-wrap">{formData.remarks}</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* Submit Button - Fixed at Bottom */}
//             <div className="fixed bottom-0 right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white border-t border-gray-200 px-4 sm:px-6 py-4">
//               <div className="flex gap-3">
//                 <button
//                   type="button"
//                   onClick={onClose}
//                   disabled={loading}
//                   className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={loading || !formData.visitDate}
//                   className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
//                 >
//                   {loading ? (
//                     <>
//                       <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                       </svg>
//                       Adding...
//                     </>
//                   ) : (
//                     'Add Follow-up'
//                   )}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FollowUpForm;


// components/FollowUpForm.jsx
import React, { useState, useEffect } from 'react';
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';
import { toast } from 'react-toastify';
import { visitTypeOptions, visitSubType } from './IndustryData';

const FollowUpForm = ({ visitId, clientId, isOpen, onClose, onSuccess }) => {
  const [errors, setErrors] = useState({});
  
  // Helper function to get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };
  
  // Helper function to get current time in HH:MM format
  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };
  
  const [formData, setFormData] = useState({
    visitDate: getCurrentDate(),
    visitTime: getCurrentTime(),
    visitType: '',
    nextFollowUpDate: '',
    nextFollowUpTime: '',
    remarks: ''
  });

  const [loading, setLoading] = useState(false);

  // Reset form with current date/time when modal opens
  useEffect(() => {
    if (isOpen) {
      setFormData({
        visitDate: getCurrentDate(),
        visitTime: getCurrentTime(),
        visitType: '',
        nextFollowUpDate: '',
        nextFollowUpTime: '',
        remarks: ''
      });
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Visit Type Validation
    if (!formData.visitType) {
      newErrors.visitType = 'Please select a visit type';
    }

    // Visit Date Validation
    if (!formData.visitDate) {
      newErrors.visitDate = 'Visit date is required';
    }

    // Visit Time Validation
    if (!formData.visitTime) {
      newErrors.visitTime = 'Visit time is required';
    }

    // Remarks Validation
    if (!formData.remarks.trim()) {
      newErrors.remarks = 'Visit remarks are required';
    }
      // Stop submit if validation errors exist
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fill all required fields');
      return;
    }

    setErrors({});
    setLoading(true);
    
    try {
      // API call to add follow-up
      const response = await api.post(SummaryApi.addFollowUp.url(visitId),
        formData,
      );

      if (response.data.success) {
        toast.success('Follow-up added successfully!');
        onSuccess();
        
        // Reset form with current date/time
        setFormData({
          visitDate: getCurrentDate(),
          visitTime: getCurrentTime(),
          visitType: '',
          visitSubType: "followUp",
          nextFollowUpDate: '',
          nextFollowUpTime: '',
          remarks: ''
        });
      }
    } catch (error) {
      console.error('Error adding follow-up:', error);
      toast.error(error.response?.data?.message || 'Failed to add follow-up');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className={`fixed inset-0 top-[57px] md:top-[65px] bg-black transition-opacity duration-300 z-50 ${
          isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Offcanvas */}
      <div className={`fixed inset-y-0 top-[57px] md:top-[65px] right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-white">Add Follow-up Visit</h2>
              <p className="text-sm text-blue-100 mt-1">Client ID: {clientId}</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Form */}
        <div className="h-full overflow-y-auto pb-40">
          <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
            {/* Visit Type */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Visit Type <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-3 gap-3">
                {visitTypeOptions.map((type, index) => (
                  <button
                    key={type.id}
                    type="button"
                    // onClick={() => setFormData({ ...formData, visitType: type.id })}
                    onClick={() => {
                      setFormData({
                        ...formData,
                        visitType: type.id
                      });

                      setErrors({
                        ...errors,
                        visitType: ''
                      });
                    }}
                    className={`px-4 py-3 rounded-lg border-2 transition-all ${
                      formData.visitType === type.id
                        ? index === 0 ? 'border-blue-500 bg-blue-50 text-blue-700' :
                          index === 1 ? 'border-green-500 bg-green-50 text-green-700' :
                          'border-purple-500 bg-purple-50 text-purple-700'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <span className="text-lg mb-1 block">{type.label.split(' ')[0]}</span>
                    <span className="text-xs">{type.label.split(' ').slice(1).join(' ')}</span>
                  </button>
                ))}
              </div>
              {errors.visitType && (
                <p className="text-red-500 text-xs mt-2">
                  {errors.visitType}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Visit Sub Type
              </label>

              <select
                value={formData.visitSubType}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    visitSubType: e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                {visitSubType.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>



            {/* Visit Date and Time */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Visit Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  value={formData.visitDate}
                  // onChange={(e) => setFormData({ ...formData, visitDate: e.target.value })}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      visitDate: e.target.value
                    });

                    setErrors({
                      ...errors,
                      visitDate: ''
                    });
                  }}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors.visitDate
                      ? 'border-red-500'
                      : 'border-gray-300'
                  }`}
                />
                {errors.visitDate && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.visitDate}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Visit Time <span className="text-red-500"> *</span>
                </label>
                <input
                  type="time"
                  value={formData.visitTime}
                  // onChange={(e) => setFormData({ ...formData, visitTime: e.target.value })}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      visitTime: e.target.value
                    });

                    setErrors({
                      ...errors,
                      visitTime: ''
                    });
                  }}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors.visitTime
                      ? 'border-red-500'
                      : 'border-gray-300'
                  }`}
                />
                {errors.visitTime && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.visitTime}
                  </p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            {/* Next Follow-up Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Next Follow-up Date (Optional)
              </label>
              <input
                type="date"
                value={formData.nextFollowUpDate}
                onChange={(e) => setFormData({ ...formData, nextFollowUpDate: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                min={formData.visitDate || getCurrentDate()}
              />
              <p className="text-xs text-gray-500 mt-1">
                Leave empty if no follow-up is needed after this visit
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                  Next Follow-up Time
              </label>

              <input
                  type="time"
                  value={formData.nextFollowUpTime}
                  onChange={(e) =>
                    setFormData({
                        ...formData,
                        nextFollowUpTime: e.target.value
                    })
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              />
            </div>
            </div>
            {/* Remarks */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Visit Remarks / Notes
                <span className="text-red-500"> *</span>
              </label>
              <textarea
                value={formData.remarks}
                // onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    remarks: e.target.value
                  });

                  setErrors({
                    ...errors,
                    remarks: ''
                  });
                }}
                rows={4}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none ${
                  errors.remarks
                    ? 'border-red-500'
                    : 'border-gray-300'
                }`}
                placeholder="Add any notes, discussion points, or outcomes from this visit..."
              />
              {errors.remarks && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.remarks}
                </p>
              )}
            </div>

            {/* Quick Templates */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Quick Templates
              </label>
              <div className="flex flex-wrap gap-2">
                {[
                  'Product Demo Scheduled',
                  'Price Negotiation',
                  'Technical Discussion',
                  'Contract Review',
                  'Requirements Gathering',
                  'Final Decision Pending'
                ].map((template) => (
                  <button
                    key={template}
                    type="button"
                    onClick={() => {
                      const currentRemarks = formData.remarks;
                      const newRemarks = currentRemarks 
                        ? `${currentRemarks} ${template}` 
                        : `${template}`;
                      setFormData({ ...formData, remarks: newRemarks });
                    }}
                    className="px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
                  >
                    {template}
                  </button>
                ))}
              </div>
            </div>

            {/* Visit Summary Preview */}
            {(formData.visitDate || formData.visitType || formData.remarks) && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h4 className="text-sm font-medium text-blue-900 mb-2">Visit Summary Preview</h4>
                <div className="space-y-1 text-xs text-blue-700">
                  {formData.visitDate && (
                    <p>
                      <span className="font-medium">Date:</span> {new Date(formData.visitDate).toLocaleDateString('en-IN', {
                        weekday: 'long',
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                      {formData.visitTime && ` at ${formData.visitTime}`}
                    </p>
                  )}
                  <p>
                    <span className="font-medium">Type:</span>{" "}
                    {formData.visitType === "inPerson"
                      ? "🤝 In Person"
                      : formData.visitType === "inBound"
                      ? "📥 Inbound Call"
                      : formData.visitType === "outBound"
                      ? "📞 Outbound Call"
                      : "-"}
                  </p>
                  {(formData.nextFollowUpDate ||
                    formData.nextFollowUpTime) && (

                    <p>

                        <span className="font-medium">
                          Next Follow-up:
                        </span>

                        {" "}

                        {formData.nextFollowUpDate &&
                          new Date(
                              formData.nextFollowUpDate
                          ).toLocaleDateString(
                              'en-IN',
                              {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                              }
                          )
                        }

                      {
                        formData.nextFollowUpTime &&
                        ` at ${new Date(
                            `1970-01-01T${formData.nextFollowUpTime}`
                        ).toLocaleTimeString(
                            'en-IN',
                            {
                              hour: 'numeric',
                              minute: '2-digit',
                              hour12: true
                            }
                        )}`
                      }

                    </p>
                  )}
                  {formData.remarks && (
                    <div className="mt-2">
                      <span className="font-medium">Notes:</span>
                      <p className="mt-1 whitespace-pre-wrap">{formData.remarks}</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Submit Button - Fixed at Bottom */}
            <div className="fixed bottom-0 right-0 w-full sm:max-w-md lg:max-w-xl xl:max-w-3xl bg-white border-t border-gray-200 px-4 sm:px-6 py-4">
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={loading}
                  className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                >
                  {loading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Adding...
                    </>
                  ) : (
                    'Add Follow-up'
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FollowUpForm;
